export default "__VITE_ASSET__Ln6dw6Nl__"